import { render, staticRenderFns } from "./TableRowFraud.vue?vue&type=template&id=b98923d4"
import script from "./TableRowFraud.vue?vue&type=script&lang=js"
export * from "./TableRowFraud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports